import { create } from 'zustand';

/**
 * EL ESTADO DE LA PUERTA, en memoria y a propósito fuera de IndexedDB.
 *
 *  · `accediendo`: mientras la pantalla de acceso trabaja (crear, entrar, bajar lo
 *    tuyo) sigue en pantalla aunque la cuenta ya esté vinculada. Sin esto, la puerta
 *    saltaba a la app a mitad de «Bajando lo tuyo».
 *  · `codigo`: el código de recuperación recién generado, para enseñarlo una sola vez.
 *    Nunca se guarda en el dispositivo: quien lo pierda genera otro en Ajustes.
 *  · `pedirUsuario`: cuentas de antes (con correo) que aún no eligieron usuario.
 */
type Acceso = {
  accediendo: boolean;
  codigo: string | null;
  pedirUsuario: boolean;
  setAccediendo: (v: boolean) => void;
  mostrarCodigo: (codigo: string, pedirUsuario?: boolean) => void;
  cerrarCodigo: () => void;
};

export const useAcceso = create<Acceso>((set) => ({
  accediendo: false,
  codigo: null,
  pedirUsuario: false,
  setAccediendo: (accediendo) => set({ accediendo }),
  mostrarCodigo: (codigo, pedirUsuario = false) => set({ codigo, pedirUsuario }),
  cerrarCodigo: () => set({ codigo: null, pedirUsuario: false }),
}));
